import { Provider } from '@angular/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export function provideAppTranslationLoader(): Provider[] {
  return provideTranslateHttpLoader({
    prefix: 'assets/i18n/',
    suffix: '-lang.json',
    failOnError: true
  });
}
